<!-- 加油记录 -->
<template>
    <div class='page_content'>
        <oilCardRefuelingAction ref="oilCardRefuelingAction"></oilCardRefuelingAction>

        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" :flagList="[]" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
                </vSearch>
            </div>
        </div>
        <div class="page_content_center">
            <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
                <el-table-column label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <!-- 主表单 -->
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip :min-width="tableValye.fieldWeight">
                        <template slot="header">
                            <div>
                                <el-tooltip :content="tableValye.showField" placement="top">
                                    <div class="long_title"><span>{{ tableValye.showField }}</span></div>
                                </el-tooltip>
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <!-- 油卡状态 -->
                            <template v-if="tableValye.entityField == 'cardState'">
                                <el-tag v-if="tableValye.formatterContent" size="mini">
                                    {{ $common.getIsGsp(tableValye.formatterContent, scope.row.cardState) }}</el-tag>
                            </template>

                            <!-- 油卡类型 -->
                            <span v-else-if="tableValye.entityField == 'cardType'">{{
                                    getOilTypeStr(scope.row[tableValye.entityField]) }}</span>

                            <!-- 加油时间 -->
                            <template v-else-if="tableValye.entityField == 'fuelDate'">
                                <span v-if="scope.row[tableValye.entityField]">{{
                                        $common.getLocalTime(scope.row[tableValye.entityField]) }}</span>
                            </template>

                            <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>

        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "@/byComponents/SearchScheme.vue";
import oilCardRefuelingAction from "@/components/oilCardRefuelingAction.vue";

export default {
    //import引入的组件需要注入到对象中才能使用
    components: { SearchScheme, oilCardRefuelingAction },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: { //列表数据请求参数
                page: 1,
                rows: 30,
                start: "",
                end: "",
                "cardCode": "", //加油卡编号
                "creater": 0,
                "ormId": '',
                "carNum": "", //车牌号
                "gasStationName": "", //加油站名称
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [], //头部按钮列表
            pageShowData: [],
            selectedDataIndex: 0,
            oilCardTypeList: [], //油卡类型
            seId: "",
            seWidth: "",
            seTitle: "",
            seWidth: "",
            DialogVisible: false,
            parentSearchData: {},
            seType: "",

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 删除数据
        delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.recordId],
                    }
                    let responseData = await this.$http.cardrecordDelete(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });
                        this.selectedDataIndex = 0
                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    this.$refs["oilCardRefuelingAction"].openBox(actionData.actionType, this.formDataList, "")
                    break;
                case 1:
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.$refs["oilCardRefuelingAction"].openBox(actionData.actionType, this.formDataList,
                        dataInfo)
                    break;
                case 2:
                    this.delDataAction();
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.cardrecordQuery(this.getRequestData);
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.formDataList = this.pageShowData.jurFormVoList
                this.getDataList();
                this.getButtonList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //获取油卡类型
        async getOilType() {
            let responseData = await this.$http.getCateDictionariesData({
                ids: [36],
            })
            if (responseData.status == 200) {
                this.oilCardTypeList = responseData.result
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                })
            }
        },
        //获取油卡类型字符
        getOilTypeStr(str) {
            let num = parseFloat(str)
            let getStr = ''
            this.oilCardTypeList.forEach((v) => {
                if (v.diId == num) {
                    getStr = v.diName
                    return false
                }
            })
            return getStr
        },
        

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
// 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.seType = type;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        //提取返回
        changeInputModel(val) {
            // console.log(this.seType,val)

            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
        this.getOilType()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>